<ng-template [ngIf]="isUploadingFile || isReadingBarcode">
  <app-loading></app-loading>
</ng-template>
   <div class="d-flex mt-2">
        <div class="grid formgrid p-fluid">
            
          <div class="field mt-2 mb-2 col-12">
        
          <p-fileUpload 
                mode="basic" 
                name="caricaFile"
                multiple="false"
                maxFileSize="5000000000"
                [accept]="acceptedFileTypes"
                [auto]="false"
                chooseLabel="{{label}}"
                chooseIcon="{{icona}}"
                uploadIcon="{{icona}}"
                uploadLabel="{{label}}"
                [styleClass]="fileClass"
                (onUpload)="onFileUpload($event)" 
                (onSelect)="onFileSelect($event)" 
                url="https://www.primefaces.org/cdn/api/upload.php"
            >
          </p-fileUpload>
      </div>

      <!-- Sezione per mostrare il risultato della lettura del codice a barre -->
      <div class="field mt-2 mb-2 col-12" *ngIf="file">
        
        <!-- Indicatore di caricamento per la lettura -->
        <div *ngIf="isReadingBarcode" class="text-center p-3">
          <p-progressSpinner [style]="{'width': '30px', 'height': '30px'}"></p-progressSpinner>
          <p class="mt-2">Lettura codice a barre in corso...</p>
        </div>

        <!-- Successo nella lettura -->
        <div *ngIf="barcodeReadSuccess && !isReadingBarcode" class="p-3 bg-green-100 border-green-300 border-1 border-round">
          <div class="flex align-items-center">
            <i class="pi pi-check-circle text-green-600 mr-2"></i>
            <span class="font-bold text-green-800">Codice a barre letto con successo!</span>
          </div>
          <div class="mt-2">
            <label class="font-medium text-700">Valore:</label>
            <p class="font-mono bg-white p-2 border-round mt-1 text-900 font-bold">{{ codiceBarre }}</p>
          </div>
        </div>

        <!-- Errore nella lettura -->
        <div *ngIf="barcodeError && !isReadingBarcode && !barcodeReadSuccess" class="p-3 bg-red-100 border-red-300 border-1 border-round">
          <div class="flex align-items-center">
            <i class="pi pi-times-circle text-red-600 mr-2"></i>
            <span class="font-bold text-red-800">Errore nella lettura del codice a barre</span>
          </div>
          <p class="mt-2 text-red-700">{{ barcodeError }}</p>
          <p class="mt-1 text-red-600 text-sm">Suggerimenti:</p>
          <ul class="text-red-600 text-sm mt-1 ml-3">
            <li>Assicurati che l'immagine sia chiara e ben illuminata</li>
            <li>Il codice a barre deve essere completamente visibile</li>
            <li>Prova con un'immagine di qualità migliore</li>
          </ul>
        </div>
      </div>

   </div>

    <div class="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
    <div class="margin-top-1" style="text-align: center; display: flex; justify-content: center; align-items: center;">
      <p-button icon="pi pi-times" (onClick)="conferma(false)" label="Annulla" class="p-button-text mr-2"
      styleClass="p-button-warning"></p-button>
     <p-button  icon="pi pi-check" label="Conferma"
      class="p-button-text ml-100" styleClass="p-button-success" 
      (click)="conferma(true)" 
      [disabled]="isUploadingFile || isReadingBarcode || !files || !barcodeReadSuccess"></p-button>
  </div>
    <p-toast />
